import React from "react";
import "../../Assets/css/about.css";
import { Link } from "react-router-dom";
import twitter from "../../Assets/img/twitter.webp";
import polkta from "../../Assets/img/polkta.webp";
import youtube from "../../Assets/img/youtube.webp";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import Footeragain from "../../Components/Footeragain";

const About = () => {
  return (
    <>
      <Header />
      {/* First section  */}
      <section className="About-first-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="About-first-text">
                <div className="dv-text about-dv-text">
                  <h2 className="for-respoinsive-heading">
                    MIGHTY WINGS –{" "}
                    <span>
                      THE LARGEST <br /> DECENTRALIZED METAVERSE <br /> OF THE
                      PRESENT TIMES
                    </span>
                  </h2>
                  <p className="about-para-responsive">
                    Mighty Wings is a decentralized NFT gaming Meta-verse based
                    on Ethereum Blockchain. With complete autonomy, users
                    can buy their NFTs and virtual lands,engage in
                    battles and fights, and monetize their gaming
                    experiences to maximize their profits.
                  </p>
                </div>
                {/* <div className="dv-text about-dv-text">
                  <h2 className="for-respoinsive-heading">
                    OUR <span>VISION</span>
                  </h2>
                  <p className="about-para-responsive">
                    We aspire to create the largest decentralized prehistoric
                    world of <br /> Meta-verse that is owned by the community so
                    that they can play, create, collect, <br /> earn, and even
                    govern lands in the game with tangible benefits outside of
                    the game.
                  </p>
                </div>
                <div className="dv-text about-dv-text">
                  <h2 className="for-respoinsive-heading">
                    OUR <span>MISSION </span>
                  </h2>
                  <p className="about-para-responsive">
                    To help traders, investors, and the blockchain community
                    understand the <br /> potential of decentralized technology;
                    And be the voice for all people looking <br />
                    to disrupt the existing technology so that there is no
                    compromise on <br />
                    creativity, technology, beauty, or user experience.
                  </p>
                </div> */}
              </div>
            </div>
            <div className="col-md-6"></div>
          </div>
        </div>
        <div className="seprator top"></div>
        <div className="seprator bottom"></div>
      </section>
      {/* End of First section  */}

      {/* Second section  */}
      <section className="About-second-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="about-second-text">
                <div className="dv-text about-dv-text">
                  <h2 className="for-respoinsive-heading">
                    CRYPTOGRAPHICALLY <br />
                    <span>
                      SECURED, ETHEREUM <br /> BLOCKCHAIN-BASED <br />{" "}
                      MARKETPLACE
                    </span>
                  </h2>
                  <p className="about-para-responsive">
                    Like all the times and lands, the currency is an essential
                    mode for governance  and economics, and this is why we
                    have utilized the best transaction-based state
                    mechanics –Ethereum Blockchain –to create [INSERT TOKEN
                    NAME],which is the native ERC-20 Utility Token of{" "}
                    Mighty Wings Universe.
                  </p>
                  <p className="mt-3">
                    It serves as the basis for all types of trades within the
                    platform with safety and security features.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="seprator top"></div>
        <div className="seprator bottom"></div>
      </section>
      {/* End of second section  */}

      {/* Third section  */}
      <section className="About-third-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="About-first-text">
                <div className="dv-text about-dv-text">
                  <h2 className="for-respoinsive-heading">
                    OUR <span>VISION</span>
                  </h2>

                  <p className="about-para-responsive">
                    We aspire to create the largest decentralized prehistoric
                    world of Meta-verse that is owned by the community
                    so that they can play, create, collect, earn, and
                    even govern lands in the game with tangible
                    benefits outside of the game.
                  </p>
                </div>
                <div className="dv-text about-dv-text mt-5">
                  <h2 className="for-respoinsive-heading">
                    OUR
                    <span>MISSION </span>
                  </h2>

                  <p className="about-para-responsive">
                    To help traders, investors, and the blockchain community
                    understand the potential of decentralized
                    technology; And be the voice for all people{" "}
                    looking to disrupt the existing technology so that there is
                    no compromise on creativity, technology, beauty,
                    or user experience.
                  </p>
                  {/* <p className="about-para-responsive">
                    Thus, we are on a mission to create a virtually-immersive
                    environment that <br /> combines diverse settings from the
                    prehistoric era of Gods <br /> and Pantheon and lets the
                    users explore historical lands, their <br /> eras, and Gods
                    through our products.
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="seprator top"></div>
        <div className="seprator bottom"></div>
      </section>
      {/* End of Third section  */}

      {/* Join our social icon  */}
      <section className="social-icon-sec social-about">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="social-head">
                <h5>JOIN OUR SOCIAL MEDIA</h5>
                <ul>
                  <li>
                    <Link to="/">
                      <img src={twitter}></img>
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <img src={polkta}></img>
                    </Link>
                  </li>
                  <li>
                    <Link to="/">
                      <img src={youtube}></img>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End of our social icon  */}

      <Footeragain />
    </>
  );
};

export default About;
